import MicroModal from 'micromodal';

const VIDEO_MODAL_ID = 'video-preview-modal';

function ensureVideoModal() {
  let modal = document.getElementById(VIDEO_MODAL_ID);
  if (modal) return modal;

  modal = document.createElement('div');
  modal.id = VIDEO_MODAL_ID;
  modal.className = 'modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = `
    <div class="overlay" tabindex="-1" data-micromodal-close="true">
      <div class="video-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="video-modal-title">
        <button class="video-modal-close" aria-label="Close" data-micromodal-close="true">
          <i class="pd-icon icon-cancel text-base" aria-hidden="true"></i>
        </button>
        <h1 id="video-modal-title" class="sr-only">Video Player</h1>
        <iframe class="video-modal-iframe" allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
        </iframe>
        <p class="video-modal-caption"></p>
      </div>
    </div>`;
  document.body.appendChild(modal);
  return modal;
}

function openVideoModal(embedUrl, caption) {
  const modal = ensureVideoModal();
  modal.querySelector('.video-modal-iframe').src = embedUrl;
  const captionEl = modal.querySelector('.video-modal-caption');
  captionEl.textContent = caption || '';
  captionEl.style.display = caption ? '' : 'none';

  MicroModal.show(VIDEO_MODAL_ID, {
    disableScroll: true,
    onClose: () => {
      modal.querySelector('.video-modal-iframe').src = '';
    },
  });
}

// Delegated click handler for video thumbnails on benefit pages
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('.video-embed-thumbnail');
  if (!thumbnail) return;

  event.preventDefault();
  event.stopPropagation();
  openVideoModal(thumbnail.dataset.embedUrl, thumbnail.dataset.caption);
});
